import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Auth from "../screens/Auth/Auth";
import Home from "../screens/Home/Home";
import MatchDetails from "../screens/Matches/MatchDetails";
import OutletComponent from "../components/OutletComponent";
import PrivateRoute from "../screens/PrivateRoute";
import TournamentDashboard from "../screens/Tournaments/TournamentDashboard";
import TeamDetails from "../screens/Tournaments/TeamDetails";
import AutionAuth from "../screens/AutionAuth/AutionAuth";
import AuctionLayout from "../layouts/AuctionLayout";
import AuctionDetails from "../screens/AutionDetails/AuctionDetails";
import AuctionBidding from "../screens/AuctionBidding/AuctionBidding";
import TeamPlayersScreen from "../screens/AutionDetails/TeamPlayers";
import ProtectAuction from "../screens/ProtectAuction";
import AuctionData from "../screens/AuctionData/AuctionData";

const PageRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const RedirectPage = ({ file }) => {
    useEffect(() => {
      window.location.href = `/${file}.html`; // redirect to your HTML file in public folder
    }, [file]);

    return null;
  };
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={"/auction-auth"} />} />
        <Route
          path="/privacypolicy"
          element={<RedirectPage file="privacypolicy" />}
        />
        <Route
          path="/deleteaccount"
          element={<RedirectPage file="deleteaccount" />}
        />
        <Route
          path="/termsandcondition"
          element={<RedirectPage file="termsandcondition" />}
        />
        <Route path="/auth" element={<Auth />} />
        <Route path="/auction-auth" element={<AutionAuth />} />
        <Route path="/auction" element={<ProtectAuction />}>
          <Route element={<AuctionLayout />}>
            <Route path="auction-details" element={<AuctionDetails />} />
            <Route path="auction-data" element={<AuctionData />} />
            <Route path="bidding" element={<AuctionBidding />} />
            <Route
              path="team/:teamId/players"
              element={<TeamPlayersScreen />}
            />
          </Route>
        </Route>
        <Route path="/user" element={<PrivateRoute />}>
          {/* This is for common header */}
          <Route element={<OutletComponent />}>
            <Route path="home" element={<Home />} />
            <Route path="matchDetails" element={<MatchDetails />} />
            <Route
              path="tournamentDashboard"
              element={<TournamentDashboard />}
            />
            <Route path="teamDetails" element={<TeamDetails />} />
          </Route>
          {/* This is for common header */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default PageRoutes;
